/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import LoadPanel from "devextreme-react/load-panel";
import notify from "devextreme/ui/notify";
import { useDispatch, useSelector } from "react-redux";
import {
  IsPermisionPathRequired,
  getLeaveSummary,
  showSymbol,
  showEmployee,
} from "../../../redux/actions";
import {
  responseMiddleware,
  responseLeave,
  responseSymbol,
  responseEmployee,
} from "../../../redux/reducers";
import FormComponent from "./FormComponent";
import DataGridRender from "./DataGrid";
import { useScreenSize } from "../../../utils/media-query";
import { axios } from "../../../common";
import { useAuth } from "../../../contexts/auth";
import "./style.scss";
import Guid from "devextreme/core/guid";
import { getParentPath } from "../../../common";
import UsingIntl from "../../../services/using_intl";
import { formatMessage } from "devextreme/localization";
import { validateNullOrEmpty } from "../../../middlewares/validate";

export default function LeaveRegistrationgDetail() {
  const { slug } = useParams();
  const formData = useRef({});
  const history = useHistory();
  const dispatch = useDispatch();
  const { isXSmall, isSmall } = useScreenSize();
  const { user } = useAuth();
  const [employeeOid, setEmployeeOid] = React.useState();
  const { employee, loadingEmployee } = useSelector(responseEmployee);
  const { leaveSummary } = useSelector(responseLeave);
  const { symbol } = useSelector(responseSymbol);
  const [isDisable, setIsDisable] = React.useState(false);

  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const PARENT_PATH = getParentPath();

  useEffect(() => {
    UsingIntl("P0014");
    dispatch(IsPermisionPathRequired(PARENT_PATH));
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, CreateState, ReadState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (CreateState !== undefined && !CreateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }

      if (!user.EmployeeOid) {
        window.location.reload();
        return;
      }
      dispatch(getLeaveSummary(user?.EmployeeOid));
      dispatch(showSymbol());
      dispatch(showEmployee());
    }
  }, [middleware]);

  useEffect(() => {
    const getLeaveRegistration = async () => {
      const { data } = await axios.get(
        `LeaveRegistration(${slug})/?$expand=Symbol,Employee($expand=Department,Position)`,
        {
          headers: {
            MappedState: 1,
          },
        }
      );
      formData.current = data;
      setEmployeeOid(new Guid(data?.Employee.Oid));
    };
    getLeaveRegistration();
  }, [slug]);

  const handleSaveRegistration = async () => {
    if (!isDisable) {
      setIsDisable(true);
      const payload = {
        ...formData.current,
        EmployeeOid: formData.current.Employee.Oid,
      };
      const validate = {
        LeaveType: payload.LeaveType,
        FromDate: payload.FromDate,
        ToDate: payload.ToDate,
        SymbolOid: payload.SymbolOid,
      };
      const isNull = validateNullOrEmpty(validate);
      if (isNull) {
        notify("Please fill all fields", "warning", 3000);
        setIsDisable(false);
        return;
      }
      try {
        await axios.post(`LeaveRegistration`, payload, {
          headers: {
            MappedState: 1,
          },
        });

        setIsDisable(false);
        notify(formatMessage("SaveMessageSuccess"), "success", 2000);
        history.push(`/leave/leave-registration/list`);
      } catch (error) {
        setIsDisable(false);
        notify(error.response.data.message, error.response.data.msgType, 3000);
      }
    }
    // navigation về danh sách
  };

  return (
    <div>
      {loadingEmployee && <LoadPanel visible={loading} />}
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("LeaveRegistrationDetail")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Leave")}
          </Link>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("LeaveRegistration")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("Detail")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title"}>
            {formData.current.Employee &&
              `${formData.current.Employee.EmployeeCode} - ${formData.current.Employee.FullName}`}
          </h4>
          <div className={`page-actions`}>
            <Toolbar>
              <Item
                location="after"
                locateInMenu={isXSmall || isSmall ? "always" : "auto"}
                cssClass={"datagrid-toolbar-actions-dropdown"}
              >
                <Button
                  icon="check"
                  text={formatMessage("Save")}
                  onClick={handleSaveRegistration}
                  disabled={isDisable}
                  type="default"
                  stylingMode="outlined"
                />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className={"section-body"}>
          <FormComponent
            formData={formData}
            user={user}
            symbol={symbol}
            employee={employee}
            setEmployeeOid={setEmployeeOid}
            employeeOid={employeeOid}
          />
          <DataGridRender dataTable={leaveSummary} />
        </div>
      </div>
    </div>
  );
}
